'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kbyg = require('./kbyg');

var _kbyg2 = _interopRequireDefault(_kbyg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { kbyg: _kbyg2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/paths/index.js
// module id = 718
// module chunks = 11